function getItemUrlName({ ref, key, name }) {
  return `${(name || "Untitled")
    .trim()
    .replace(/[^a-z0-9_]+/gi, "-")
    .replace(/[-]{2,}/gi, "-")
    .replace(/[_-]+$/gi, "")}--${ref}-${key}`;
}

module.exports = getItemUrlName;
